import { createFileRoute } from "@tanstack/react-router"
import { BigBlueConfiguration } from "modules/settings/components/integrations/bigblue"
import { Crumb } from "modules/shared/lib/breadcrumbs"

export const Route = createFileRoute("/_base/_auth/settings/integrations/bigblue")({
  component: BigBlueConfiguration,
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("settings.integrations.bigblue.title"),
    })
  },
})
